module.exports = __webpack_public_path__ + "static/webconainer-971c0eaf892ccd72080bc400dbd4ac3e.png";